const centerPanel = require('../../shop/views/center-panel.view.html').trim(),
    rightPanel = require('../../shop/views/right-panel.view.html').trim();

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.authentication', {
            abstract: true,
            onExit: [
                'LoginService', function (loginService) {
                    // If the state was navigated to as a result of a prompt for login,
                    // we need to reject the promise for the prompt when we exit the login panel.
                    // If the login is successful, the promise should already have been resolved and
                    // this will do nothing.
                    loginService.rejectPromptForLogin();
                },
            ],
            views: {
                'content@root': {
                    template: `${centerPanel} ${rightPanel}`,
                },
            },
            data: {
                onAuthReturnToState: 'root',
            },
        })
        .state('shop.authentication.login', {
            url: '/securelogin?redirect',
            params: {
                toState: null,
                toStateParams: null,
                toStateOptions: { reload: false },
                customCallback: null,
            },
            onEnter: ['$rootScope', '$stateParams', 'SessionStorageWrapper', 'ShopperService', 'Settings', '$window', function ($rootScope, $stateParams, SessionStorage, shopperService, settings, $window) {
                if (settings.frontendManagement.enableMultiFactorAuth) {
                    const shopper = shopperService.refreshShopperDetails();

                    if (shopper.MfaRequired) {
                        $window.location.href = '/shop/two-step-auth';
                    }
                }

                // When toState is not specified in the stateParams use
                // previous state, if available, for redirection.
                SessionStorage.storage.PromptParams = 'Prompted';
                if (!$stateParams.toState && $rootScope.onAuthRedirectedState) {
                    $stateParams.toState = $rootScope.onAuthRedirectedState.name;
                    $stateParams.toStateParams = $rootScope.onAuthRedirectedStateParams;
                    SessionStorage.storage.PromptParams = 'Manual';
                }
            }],
            resolve: {
                authenticationMethod: ['ShopperService', function (shopperService) {
                    return shopperService.getAuthenticationMethod().then(result => result.AuthenticationMethod);
                }],
            },
            views: {
                'center-panel': {
                    controller: [
                        '$scope', '$state', '$stateParams', '$timeout', 'authenticationMethod', '$window', 'Settings', 'SessionStorageWrapper', 'ShopperService', 'UserPreferenceService', 'MultiFactorAuthenticationService', function ($scope, $state, $stateParams, $timeout, authenticationMethod, $window, settings, sessionStorageWrapper, shopperService, userPreferenceService, multiFactorAuthenticationService) {
                            this.authenticationMethod = authenticationMethod;

                            $scope.$on('login:partialsuccess', () => {
                                sessionStorageWrapper.set('2faState', JSON.stringify({ state: $state.href($stateParams.toState, $stateParams.toStateParams, { absolute: false }) }));

                                $timeout(() => {
                                    $window.location.href = '/shop/two-step-auth';
                                }, 0, false);
                            });
                            $scope.$on('login:success', () => {
                                if ($stateParams.customCallback) {
                                    $stateParams.customCallback();
                                } else {
                                    multiFactorAuthenticationService.getStatus().then((result) => {
                                        if (result.ShouldShowSetup) {
                                            sessionStorageWrapper.set(
                                                '2faState',
                                                JSON.stringify({ state: $state.href($stateParams.toState, $stateParams.toStateParams, { absolute: false }) }),
                                            );

                                            $timeout(() => {
                                                $window.location.href = '/shop/two-step-auth/setup';
                                            }, 0, false);
                                        } else {
                                            $timeout(() => {
                                                window.location.href = $stateParams.redirect || ($stateParams.toState
                                                    ? $state.href($stateParams.toState, $stateParams.toStateParams, $stateParams.toStateOptions) || '/'
                                                    : '/');
                                            }, 0, false);
                                        }
                                    });
                                }
                            });
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-login-page authentication-method="$ctrl.authenticationMethod"></wow-login-page>',
                },
            },
            data: {
                pageMetadata: {
                    title: 'Woolworths Supermarket - Buy Groceries Online',
                    metaDescription: 'Woolworths Supermarket - Buy Groceries Online',
                },
            },
        })
        // Reset password
        .state('shop.authentication.resetpassword', {
            url: '/resetpassword?passwordResetToken',
            views: {
                'center-panel': {
                    controller: [
                        '$stateParams', function ($stateParams) {
                            this.passwordResetToken = $stateParams.passwordResetToken;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-reset-password password-reset-token="{{::$ctrl.passwordResetToken}}"></wow-reset-password>',
                },
            },
        })
        // Forgot password
        .state('shop.authentication.forgotpassword', {
            url: '/forgotpassword',
            views: {
                'center-panel': {
                    template: '<wow-login-forgot-password></wow-login-forgot-password>',
                },
            },
        });

    require('./authentication-signup')($stateProvider);
};



// WEBPACK FOOTER //
// ./src/configuration/routes/authentication.js